/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import styled, { css } from 'styled-components'
// @ts-ignore
import { Button, Cross as CrossIcon } from '@netbasequid/core'
import { useDisplayTheme, useSysTheme } from 'hooks/useUiState'
import { SystemTheme } from 'hooks/useUiState/types'
import { Theme } from 'features/ui/types'
// @ts-ignore
import { ref } from '@netbasequid/theme'
import openHelpPage from 'utils/helpLinkUtil'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from 'app/hooks'
import { setIntroductionToolTips } from 'features/ui/uiSlice'

const TopTriangleStyle = css<{
  $mode: Theme
  $placement: 'right' | 'bottom'
}>`
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid
    ${({ $mode }) => ($mode === 'light' ? ref.color.teal[50] : ref.color.teal[1100])};
  filter: drop-shadow(0px -2px 1px rgba(0, 0, 0, 0.03));

  top: -12px;
  left: 24px;
`
const LeftTriangleStyle = css<{
  $mode: Theme
  $placement: 'right' | 'bottom'
}>`
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-right: 12px solid
    ${({ $mode }) => ($mode === 'light' ? ref.color.teal[50] : ref.color.teal[1100])};
  filter: drop-shadow(-2px 1px 1px rgba(0, 0, 0, 0.08));

  left: -12px;
  top: calc(50% - 12px);
`

const IconContainer = styled.div``

const TooltipContainer = styled.div<{
  $theme: SystemTheme
  $mode: Theme
  $placement: 'right' | 'bottom'
}>`
  background-color: ${({ $mode }) =>
    $mode === 'light' ? ref.color.teal[50] : ref.color.teal[1100]};
  padding: 16px;
  box-sizing: border-box;
  box-shadow: ${({ $theme }) => $theme.elevation[300].boxShadow};
  border-radius: 2px;

  &:before {
    content: '';
    display: block;
    position: absolute;

    ${({ $placement }) => ($placement === 'right' ? LeftTriangleStyle : TopTriangleStyle)}
  }

  & > .intro-tooltip-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    color: ${({ $theme }) => $theme.text.primary};
    font-size: ${({ $theme }) => $theme.typescale[16].size};
    font-weight: ${({ $theme }) => $theme.fontWeight.semibold};
    & > :nth-child(2) {
      cursor: pointer;
    }
  }
  & > .intro-tooltip-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-size: ${({ $theme }) => $theme.typescale[14].size};
    line-height: ${({ $theme }) => $theme.typescale[14].lineHeight};
    color: ${({ $theme }) => $theme.text.primary};
  }
  & > .intro-tooltip-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
  }
`

const ClickableText = styled.span<{ $theme: SystemTheme }>`
  cursor: pointer;
  color: ${({ $theme }) => $theme.interaction.primary.default};
  font-size: ${({ $theme }) => $theme.typescale[14].size};
  line-height: ${({ $theme }) => $theme.typescale[14].lineHeight};
  text-decoration: underline;
  &:hover {
    color: ${({ $theme }) => $theme.interaction.primary.hover};
  }
  &:active {
    color: ${({ $theme }) => $theme.interaction.primary.pressed};
  }
`

export const SidePannelIntroductionTooltip = () => {
  const mode = useDisplayTheme()
  const theme = useSysTheme()
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const handleClose = () => {
    dispatch(setIntroductionToolTips({ sidePanelIsRead: true }))
  }

  return (
    <TooltipContainer
      $theme={theme}
      $mode={mode}
      $placement="right"
      style={{
        position: 'absolute',
        top: 'calc(48px + 8px)',
        left: '68px',
        zIndex: 2013,
        width: 448
      }}>
      <div className="intro-tooltip-title">
        <span>{t('introductionTooltips.sidePanel.title')}</span>
        <IconContainer onClick={handleClose}>
          <CrossIcon mode={mode} />
        </IconContainer>
      </div>
      <div className="intro-tooltip-content">{t('introductionTooltips.sidePanel.content')}</div>
      <div className="intro-tooltip-footer">
        <Button mode={mode} color="primary" onClick={handleClose}>
          {t('gotIt')}
        </Button>
      </div>
    </TooltipContainer>
  )
}

export const LabelIntroductionTooltip = () => {
  const mode = useDisplayTheme()
  const theme = useSysTheme()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const handleClose = () => {
    dispatch(setIntroductionToolTips({ labelsIsRead: true }))
  }

  return (
    <TooltipContainer
      $theme={theme}
      $mode={mode}
      $placement="bottom"
      style={{
        position: 'absolute',
        left: '12px',
        width: 361,
        top: '8px',
        zIndex: '2014'
      }}>
      <div className="intro-tooltip-title">
        <span>{t('introductionTooltips.labels.title')}</span>
        <IconContainer onClick={handleClose}>
          <CrossIcon mode={mode} />
        </IconContainer>
      </div>
      <div className="intro-tooltip-content">{t('introductionTooltips.labels.content')}</div>
      <div className="intro-tooltip-footer">
        <ClickableText $theme={theme} onClick={() => openHelpPage(9875603)}>
          {t('learnMore')}
        </ClickableText>
        <Button mode={mode} color="primary" onClick={handleClose}>
          {t('gotIt')}
        </Button>
      </div>
    </TooltipContainer>
  )
}
